import { render, staticRenderFns } from "./ProductionManagementList.vue?vue&type=template&id=5d364652&scoped=true"
import script from "./ProductionManagementList.vue?vue&type=script&lang=js"
export * from "./ProductionManagementList.vue?vue&type=script&lang=js"
import style0 from "./ProductionManagementList.vue?vue&type=style&index=0&id=5d364652&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d364652",
  null
  
)

export default component.exports